// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import { Button } from 'grommet'
import { ShareRounded } from 'grommet-icons'
import PropTypes from 'prop-types'

import { INTERNAL_REDIRECT_SERVICES } from '../../../../dashboard/constants'
import { saveTimestampToUPS } from '../../../../dashboard/utils'

const StaticLaunchButton = ({
  serviceOfferId,
  serviceName,
  serviceSlug,
  staticLaunchUrl,
  setRecentServices,
  LDFlags,
  axios,
  t
}) => (
  <Button
    primary
    data-testid={`${serviceSlug}-service-detail-static-launch-button`}
    label={t('dashboard:common.launch')}
    icon={
      !INTERNAL_REDIRECT_SERVICES.includes(serviceSlug) ? <ShareRounded /> : ''
    }
    reverse
    href={staticLaunchUrl}
    target={
      INTERNAL_REDIRECT_SERVICES.includes(serviceSlug) ? '_self' : '_blank'
    }
    onClick={() => {
      if (LDFlags['glcp-ups-save-launch-timestamp']) {
        saveTimestampToUPS(serviceOfferId, serviceName, axios)
      }
      setRecentServices(serviceSlug)
    }}
  />
)

StaticLaunchButton.propTypes = {
  serviceOfferId: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  serviceSlug: PropTypes.string.isRequired,
  staticLaunchUrl: PropTypes.string.isRequired,
  setRecentServices: PropTypes.func.isRequired,
  LDFlags: PropTypes.object.isRequired,
  axios: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}

export default StaticLaunchButton
